import { z } from "zod";

// Razorpay Checkout Configuration id (e.g. config_TkDZFll39bY0IQ). Blank clears
// it, which means Razorpay's default checkout for that mode.
const rzpCheckoutConfigId = z
  .string()
  .trim()
  .refine((v) => v === "" || /^config_[A-Za-z0-9]{14}$/.test(v), {
    message: "Use the 21-character Razorpay config id (config_ + 14 characters)",
  })
  .optional()
  .nullable();

export const regionSchema = z.object({
  code: z
    .string()
    .trim()
    .length(2, "Use the 2-letter ISO code (e.g. in, ae, us, sg)"),
  display_name: z.string().min(1, "Display name is required"),
  currency: z.string().trim().min(1, "Currency is required"),
  timezone: z.string().trim().min(1, "Timezone is required"),
  default_locale: z.string().trim().optional(),
  price_floor_minor: z.number().int().optional().nullable(),
  price_ceiling_minor: z.number().int().optional().nullable(),
  is_active: z.boolean().default(true),
  is_fallback: z.boolean().default(false),
  rzp_checkout_config_id: rzpCheckoutConfigId,
  rzp_test_checkout_config_id: rzpCheckoutConfigId,
});

export type RegionFormData = z.infer<typeof regionSchema>;
